module.exports = __webpack_public_path__ + "static/media/IMG_1632.6ca42d41.JPG";